/**
 * 브랜드 자산(DD-27). 레거시 Figma(oVvSulXdMlv3YSYu3ZSnAd)의 벡터를 SVG 로 받아 그대로 둔다.
 * 원본 브랜드 색이라 토큰에 묶지 않는다(design.md 예외). 다시 받는 법: 04-ui-system/index.md "브랜드 자산".
 * Vite 기본 asset import — 빌드 때 해시가 붙은 URL 이 된다.
 */
import loginIllustUrl from './brand/login-illust.svg';
import logoUrl from './brand/logo.svg';
import logoMarkUrl from './brand/logo-mark.svg';
import excelLogoUrl from './file-logo/excel.svg';
import pdfLogoUrl from './file-logo/pdf.svg';
import wordLogoUrl from './file-logo/word.svg';

export const BRAND_ASSET = {
  /** 서비스 로고(D3 | Redefining Growth). Figma `Brand/Logo` 2269:37 */
  logo: logoUrl,
  /** 로고 아이콘(마크) — 로고의 아이콘 부분만. 파비콘의 원본. Figma `Brand/LogoMark` 2313:56 */
  logoMark: logoMarkUrl,
  /** 로그인 일러스트(장식). Figma `Brand/LoginIllust` 2269:37839 */
  loginIllust: loginIllustUrl,
} as const;

/** 원본 크기(px). 비율 고정 — 폭만 정하고 높이는 비율로 */
export const BRAND_ASSET_SIZE = {
  logo: { width: 182, height: 36 },
  logoMark: { width: 16.3073, height: 18.5143 },
  loginIllust: { width: 277, height: 240 },
} as const;

/**
 * 파일 종류 로고(엑셀 · 워드 · PDF) — 각 서비스 색과 글자를 따라 직접 그린 아이콘(상표 원본이 아니다).
 * 원본 색이라 토큰에 묶지 않는다(design.md 예외). Figma `FileLogo/*`(Icons 페이지). viewBox 24, 정사각
 */
export const FILE_LOGO_ASSET = {
  excel: excelLogoUrl,
  word: wordLogoUrl,
  pdf: pdfLogoUrl,
} as const;
